import { toNano as toNanoNative } from '@ton/core';

export function toNano(tonAmount: string | bigint | number) {
  return toNanoNative(Number(tonAmount));
}
